import Vue from "vue"
import store from "./store"
import App from "./components/app.vue"

// Geolocation
navigator.geolocation.watchPosition(
  position => {
    store.dispatch("setClientPosition", position)
  },
  error => {
    alert(
      "Unable to locate your device. Please make sure geolocation is enabled on your device and your web browser allows geolocation on play.scoove.net."
    )
  },
  {
    enableHighAccuracy: true
  }
)

// Locale
const i18n = new VueI18n({
  locale: LOCALE,
  messages: {
      [LOCALE]: require('./locale/' + LOCALE + '.json')
  }
})

// Application
new Vue({
  el: "#scoov",
  i18n,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/index.js